import { BankOutlined } from '@ant-design/icons';
import { FormItemProps, SelectProps } from 'antd';
import { Domain, findDomainByText, getDomainsAgentDef } from '../../apis/mgmt/api';
import { DataOptionProps, DataSelect, DataFormItem, DataSelectProps } from '../common/DataSelect';


export const DomainOptionProps: DataOptionProps<Domain> = {
    valueFromData: (data) => data?.id,
    labelFromData: (data) => data?.slug,
}

const defaultSearch = async (searchText: string, filter?: any) => {
    const result = await findDomainByText({ search: searchText, size: 100 });
    return result.data.content || [];
}

export const DomainSelect = function<TFilter>(props: DataSelectProps<Domain,TFilter>) {
    const { search, ...restOfProps } = props;
    return (
        <DataSelect<Domain,TFilter>
            placeholder="Domain"
            suffixIcon={<BankOutlined className="site-form-item-icon" />}
            dataOptionsProps={DomainOptionProps}
            {...restOfProps}
            search={props.search || defaultSearch}
        />
    );
}

export const DomainFormItem = (props: FormItemProps<any>) => 
    <DataFormItem<Domain>
        {...props}
        dataOptionsProps={DomainOptionProps}
    />
;

export const AgentDomainSelect = (props: SelectProps<any> & { agentDefId?: string }) => {
    const { agentDefId, ...selectProps } = props;
    return (
        <DomainSelect<string>
            {...selectProps}
            searchFilter={props.agentDefId}
            search ={ async (searchText: string, agentDefId?: string) => {
                if (!agentDefId) return [];
                const result = await getDomainsAgentDef(agentDefId);
                return result.data || [];
            }}
        />
    );
}